// Toggles the fade-in once a .theme-image-img finishes loading (see
// snippets/akr-theme-image.liquid). 'load' doesn't bubble, hence capture: true.
document.addEventListener(
  'load',
  (event) => {
    if (event.target instanceof HTMLImageElement && event.target.matches('.theme-image-img')) {
      event.target.classList.add('--loaded');
    }
  },
  true,
);
